import { render } from "./ReferralMemberList.vue?vue&type=template&id=d180c8c4&scoped=true"
import script from "./ReferralMemberList.vue?vue&type=script&lang=js"
export * from "./ReferralMemberList.vue?vue&type=script&lang=js"

import "./ReferralMemberList.vue?vue&type=style&index=0&id=d180c8c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d180c8c4"]])

export default __exports__